import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKibana = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 33,
	height: 32,
	viewBox: "0 0 33 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.5 0V28.789L29.435 0.017L4.5 0Z",
		fill: "#F04E98"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.9788 16.6639L6.76782 30.7539L5.69482 31.9909H28.8858C27.6338 25.6989 24.0038 20.2719 18.9788 16.6639Z",
		fill: "#00BFB3"
	})]
});
export default SvgKibana;
